export enum PublishDestination {
	mResearch = 1,
	SurveyEngine = 2,
}
